import React, { FunctionComponent } from "react";

import { GameList } from "components";

const Home: FunctionComponent = () => {
  return <GameList />;
};

export default Home;
